'use strict';

angular.module('mean.options').controller('OptionsFileController', ['$scope', 'MeanUser', 'Global', '$filter', '$q', 'toaster', 'Options', 
  function($scope, MeanUser, Global, $filter, $q, toaster,  Options) {
    $scope.global = Global;

    $scope.user = MeanUser.user;

    $scope.fileSelected = function() {
        var lines, lineNumber, data, length;
        var options = [];
        
        lines = this.$parent.fileContent.split('\n');
        lineNumber = 0;
        var errors = false;
        //for (var i = lines.length - 1; i > 0; i--) {
        _.each(lines, function(l) {
            //var l = lines[i];

            lineNumber++;
            if(lineNumber !== 1) { //skip the first line
                data = l.split(',');

                if(data[0]) {
                    if(data.length !== 6) {
                        toaster.pop('error', 'Options File Error', 'Issue with line number ' + lineNumber);
                        return null;
                    }

                    var trades = data[3].split(';');
                    var plans_array = data[4].split(';');
                    var plans = [];

                    _.each(trades, function(trade) {
                        trade = trade.trim();
                    });

                    _.each(plans_array, function(plan) {
                        plans.push(plan.trim().toUpperCase());
                    });

                    var multiple = $filter('lowercase')(data[5].trim())

                    var value = (multiple === 'true')?true:false;

                    if(options.filter(e => e.number == data[0]).length == 0) {
                        options.push({
                            number: data[0].trim(),
                            name: data[1].trim(),
                            description: data[2].trim(),
                            trades: trades,
                            plans: plans,
                            has_multiple: value
                        });
                    } else {
                        errors = true;
                        toaster.pop('error', 'Option Number Error',
                            'Must have unique option numbers');
                        return;
                    }
                }
            }
        });

        _.remove(options, function(opt) {
            return opt.number === '';
        });

        delete this.$parent.fileContent;
        if(!errors) {
            $scope.$emit('optionsFileLoaded', options);
        }
    };

    $scope.ConvertToCSV = function(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = 'number, name, description, trades, plans, multiple';
        str += '\r\n';

        for(var i=0; i<array.length; i++) {
            str += array[i].number + ', ' + array[i].name + ', ' + array[i].description + ',';
            for(var j=0; j<array[i].trades.length; j++) {
                str += array[i].trades[j];

                if(j<array[i].trades.length-1)
                    str += '; ';
            }
            str += ', ';

            for(var j=0; j<array[i].plans.length; j++) {
                str += array[i].plans[j];

                if(j<array[i].plans.length-1)
                    str += '; ';
            }

            str += ', ';
            str += (array[i].has_multiple === true)?true:false;
            str += '\r\n';
        }

        return str;
    };

    $scope.exportFile = function(options) {
        console.log('options-file.js exportFile');
        var dataUrl = 'data:text/csv;utf-8,' + encodeURI($scope.ConvertToCSV(options));
        var link = document.createElement('a');
      
        angular.element(link)
            .attr('href', dataUrl)
            .attr('download', 'options_file.csv'); // Pretty much only works in chrome
      
        link.click();
    };
  }
]);




// WEBPACK FOOTER //
// ./packages/custom/options/public/controllers/options-file.js